import { render, staticRenderFns } from "./QuotaManageCom.vue?vue&type=template&id=30856bb6&scoped=true&"
import script from "./QuotaManageCom.vue?vue&type=script&lang=js&"
export * from "./QuotaManageCom.vue?vue&type=script&lang=js&"
import style0 from "./QuotaManageCom.vue?vue&type=style&index=0&id=30856bb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30856bb6",
  null
  
)

export default component.exports